// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
//import App from './App';

import NauPage from './NauPage';

//import DynamicForm from './DynamicForm'
import { router } from './router'

import VueMask from 'v-mask'
import Vuelidate from 'vuelidate';
import Vuex from 'vuex';


// bootstrap vue components
import { BootstrapVue } from 'bootstrap-vue';


import vuetify from '@/plugins/vuetify';
import LoanParams from '@/plugins/loan-params';

import Toasted from 'vue-toasted';


// message bus
export const bus = new Vue();    



import common from '@/mixins/common';
Vue.mixin(common);



Vue.use(LoanParams);

Vue.use(VueMask);
Vue.use(Vuelidate);

Vue.use(Vuex);
Vue.use(BootstrapVue);



Vue.use(Toasted);

// uuid generator
window.uuidv4 = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


//initialize sid
if ( localStorage.getItem('sid') ) {

  window.__sid = localStorage.getItem('sid');
}
else {

  window.__sid = window.uuidv4();

  localStorage.setItem('sid', window.__sid);
}



// fingerprint
import('../static/js/thumbmark.umd.js')
.then((thmb) => {

    thmb.getFingerprint().then((fp) => { 

      window.fingerprint = fp;
   //   console.log(fp)
    });


});





/** Vue Filters Start */
Vue.filter('truncate', function (text, length, suffix) {
    if (text.length > length) {
        return text.substring(0, length) + suffix;
    } else {
        return text;
    }
});
/** Vue Filters End */




Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  //store: store,


  router,
  vuetify,


  computed: {

    mainpage() {

      return this.$children[0];
    }
  },



  methods: {


  

  },


  render: h => h( NauPage ),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js